/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AllocationType } from '../../models/allocation-type';
import { GetMasterScheduleAllocationsResponse } from '../../models/get-master-schedule-allocations-response';
import { Rotation } from '../../models/rotation';

export interface ListMasterScheduleAllocations$Params {
  dateFrom: string;
  dateTo: string;
  rotation?: Array<Rotation>;
  crewId?: number;
  type?: AllocationType;
  base?: string;
}

export function listMasterScheduleAllocations(http: HttpClient, rootUrl: string, params: ListMasterScheduleAllocations$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMasterScheduleAllocationsResponse>> {
  const rb = new RequestBuilder(rootUrl, listMasterScheduleAllocations.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('rotation', params.rotation, {"style":"form","explode":true});
    rb.query('crewId', params.crewId, {});
    rb.query('type', params.type, {});
    rb.query('base', params.base, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMasterScheduleAllocationsResponse>;
    })
  );
}

listMasterScheduleAllocations.PATH = '/api/scheduler/master-schedule/allocations';
